import { FC, RefObject } from 'react';

import { HELP_PAGE_REGION_LIFEHACK_URL } from 'utils/constants/app';

import { ActionBar, BottomSheet, Button, NavBar, Text, Tooltip, useBreakpoint, VSpacing } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

const TrlKeys = {
    message: 'AdCreate.AdForm.Regions.info.message',
    thank: 'AdCreate.AdForm.Regions.info.thank',
    lifehack: 'AdCreate.AdForm.Regions.info.lifehack',
};

interface InfoRegionsTipProps {
    activatorRef: RefObject<HTMLDivElement>;
    visible: boolean;
    onClose: () => void;
    label: string;
}

export const InfoRegionsTip: FC<InfoRegionsTipProps> = ({ activatorRef, visible, onClose, label }) => {
    const trl = useTrls();
    const { isMobile } = useBreakpoint();

    const linkButton = (
        <Button
            size={isMobile ? 'medium' : 'small'}
            mode="primary"
            style={isMobile ? 'accent' : 'constant'}
            Element="a"
            target="_blank"
            href={HELP_PAGE_REGION_LIFEHACK_URL}
            stretched
            data-qa="info-regions-tip-lifehack-button"
        >
            {trl(TrlKeys.lifehack)}
        </Button>
    );

    return (
        <>
            <Tooltip visible={visible} onClose={onClose} activatorRef={activatorRef} placement="right-center">
                <div>
                    <Text>{trl(TrlKeys.message)}</Text>
                    <VSpacing default={16} />
                    {linkButton}
                </div>
            </Tooltip>
            <BottomSheet
                visible={visible}
                onClose={onClose}
                header={
                    <NavBar>
                        <NavBar.Pane>
                            <NavBar.Stage>
                                <NavBar.Actions centered>
                                    <NavBar.TitleContainer
                                        centered
                                        title={<Text typography="subtitle-1-semibold">{label}</Text>}
                                    />
                                </NavBar.Actions>
                            </NavBar.Stage>
                        </NavBar.Pane>
                    </NavBar>
                }
                footer={<ActionBar primaryActions={linkButton} />}
            >
                <Text>{trl(TrlKeys.message)}</Text>
            </BottomSheet>
        </>
    );
};
